module.exports = __webpack_public_path__ + "img/ruai (2).f5300e76.png";